import script from "./admin-tag-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin-tag-list.vue?vue&type=script&setup=true&lang=ts"

import "./admin-tag-list.vue?vue&type=style&index=0&id=d77f4188&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d77f4188"]])

export default __exports__